import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_CargaNoRealizada from "./ContentCargaNoRealizada";
import Footer from '../../components/Footer/Footer';

class CargaNoRealizada extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_CargaNoRealizada />
                <Footer />
            </div>

        )
    }
}

export default CargaNoRealizada;